import { hasRight, canViewCrmDashboardData } from '@/utils/auth';

/** CRM widgets whose body uses pipeline/KPI data (Lead or dashboard view). */
const CRM_PIPELINE_PORTLET_WIDGETS = new Set([
  'CRM Dashboard - Realtime KPIs',
  'CRM Dashboard - Presales Pipeline',
  'CRM Dashboard - Sales Pipeline',
]);

function isAdminUser(user) {
  const role = String(user?.role || '').toLowerCase();
  const type = String(user?.type || '').toLowerCase();
  return role === 'admin' || type === 'admin';
}

/**
 * Whether a CRM dashboard portlet should render (widget right + data/view right).
 * @param {object} user
 * @param {boolean} widgetGranted - e.g. from widgetAccess or admin bypass
 * @param {string} widgetName
 */
export function crmPortletVisible(user, widgetGranted, widgetName) {
  if (!widgetGranted) {
    return false;
  }
  if (!user || isAdminUser(user)) {
    return true;
  }
  if (widgetName === 'CRM Dashboard - Global Filters') {
    return true;
  }
  if (CRM_PIPELINE_PORTLET_WIDGETS.has(widgetName)) {
    return canViewCrmDashboardData(user);
  }
  return hasRight(user, 'dashboard', 'view');
}

/**
 * True when at least one portlet in the list should show.
 */
export function crmPortletRowVisible(user, widgetGrantedFn, widgetNames) {
  return widgetNames.some((name) =>
    crmPortletVisible(user, widgetGrantedFn(name), name)
  );
}
